import { Icon } from "semantic-ui-react"
import type { OpenAPI } from "simplydo/interfaces"

import { TooltipButton } from "components/lib/UI"

type ScrollToCommentsActionProps = {
  idea: OpenAPI.GET<"/ideas/{id}">["response"]
}

const ScrollToCommentsAction = ({ idea }: ScrollToCommentsActionProps) => {
  if (idea?.ownerChallenge?.preventIdeaComments) {
    return null
  }

  return (
    <TooltipButton
      icon
      tooltip={"Scroll to comments"}
      style={{ position: "relative" }}
      onClick={() => {
        const ideaCommentsElement = document.getElementById("idea-comments")
        if (ideaCommentsElement) {
          ideaCommentsElement.scrollIntoView({ behavior: "smooth" })
        }
      }}
    >
      <Icon name="comment" />
      {idea.commentCount ? (
        <div style={{ position: "absolute", right: 3, bottom: 0, opacity: 0.9, fontSize: 10 }}>
          {idea.commentCount || 0}
        </div>
      ) : null}
    </TooltipButton>
  )
}

export default ScrollToCommentsAction
